import { initializeApp, getApps } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
export const firebaseConfig = {
    apiKey: "AIzaSyAMOgEmHy9wyUqEg3YugjYbPbR5U9VfPWY",
    authDomain: "carmarketapp-a10cd.firebaseapp.com",
    projectId: "carmarketapp-a10cd",
    storageBucket: "carmarketapp-a10cd.firebasestorage.app",
    messagingSenderId: "63587608844",
    appId: "1:63587608844:web:394ff96d2051811f21c129",
    measurementId: "G-PXK3H1EJ0F",
};
let app = null;
export function getFirebaseApp(options) {
    if (app)
        return app;
    const isNewApp = getApps().length === 0;
    app = isNewApp ? initializeApp(firebaseConfig) : getApps()[0];
    if (isNewApp && typeof window !== "undefined" && window.location.hostname === "localhost") {
        connectAuthEmulator(getAuth(app), "http://127.0.0.1:9099", { disableWarnings: true });
        connectFirestoreEmulator(getFirestore(app), "127.0.0.1", 8080);
        connectFunctionsEmulator(getFunctions(app, "us-central1"), "127.0.0.1", 5001);
        self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }
    if (isNewApp && typeof window !== "undefined") {
        if (options?.recaptchaSiteKey) {
            initializeAppCheck(app, {
                provider: new ReCaptchaV3Provider(options.recaptchaSiteKey),
                isTokenAutoRefreshEnabled: true,
            });
        }
        else if (window.location.hostname !== "localhost") {
            console.warn("[firebase] No reCAPTCHA site key configured — App Check is not initialized. " +
                "sendOTP/verifyOTP and all admin* Cloud Functions enforce App Check and will reject requests. " +
                "See APPCHECK_SETUP.md.");
        }
    }
    return app;
}
//# sourceMappingURL=config.js.map